import React, { useEffect, useRef, useState } from 'react';
import './Home.css';
import Navbar from './Navbar';
import topicsData from './topicsData.json';
import logo from './images/semicolon.png'
import semi from './images/semi.png'
import { Link } from 'react-router-dom';

function shuffleArray(array) {
  // Shuffle the array using Fisher-Yates algorithm
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function Home() {
  const [topics, setTopics] = useState([]);
  const [currentTopicIndex, setCurrentTopicIndex] = useState(0);
  const [totalTopics, setTotalTopics] = useState(0);
  const topicsPerPage = 150;

  const topRef = useRef(null);

  const handleLogoClick = () => {
    // Scroll to the top when the logo is clicked
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Refresh the page to reset the topics
    window.location.reload();
  };
  
  useEffect(() => {
    // Shuffle the topicsData array before setting the initial topics
    const shuffledTopicsData = shuffleArray([...topicsData]);
    // Load the initial topics when the component mounts
    loadInitialTopics(shuffledTopicsData);
    // Add the scroll event listener
    window.addEventListener('scroll', handleScroll);
    // Clean up the scroll event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const loadInitialTopics = (shuffledTopicsData) => {
    // Set the initial topics from the shuffled array
    setTopics(shuffledTopicsData.slice(0, topicsPerPage));
    setTotalTopics(shuffledTopicsData.length);
  };

  const handleScroll = () => {
    // Check if the user is close to the bottom of the page
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      // Change to the next set of topics
      changeTopics();
    }
  };

  const changeTopics = () => {
    // Calculate the index of the next set of topics to display
    const nextTopicIndex = (currentTopicIndex + topicsPerPage) % totalTopics;
    // Slice the topics array to get the next set of topics
    const nextTopics = topicsData.slice(nextTopicIndex, nextTopicIndex + topicsPerPage);
    // Update the current topic index and set the new topics to display
    setCurrentTopicIndex(nextTopicIndex);
    setTopics(nextTopics);
  };

  return (
    <div className='home' ref={topRef}>
      <Navbar />
      <div className='logo-container'>
        <img src={logo} className='logo' alt='logo' onClick={handleLogoClick} />
      </div>
      <div className='home-container'>
        <div className='shorts'>
          <div className='topics-container'>
            {topics.map((topic, index) => (
              <div key={index} className='topic'>
                <h3>{topic.title}</h3>
                <p>{topic.definition}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
